import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import { withRouter } from 'react-router';
import { withUserType } from '../withUserType';
import posthog from 'posthog-js';

const LifeCycleAnalyticsPage = (props) => {
	const { userType, childRoutes } = props;

	if (!posthog.isFeatureEnabled('life-cycle-analytics')) {
		return <Redirect to={`/${userType}/analytics/assets`} />;
	}

	return (
		<AccessPermissionChecker name={PERMISSION_NAMES.ACCESS_ANALYTICS} isPage>
			<div>
				<Route
					path={`/${userType}/analytics/lifecycle`}
					exact={true}
					render={() => (
						<Redirect
							to={{
								pathname: `/${userType}/analytics/lifecycle/overview`,
							}}
						/>
					)}
				/>
				{childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		</AccessPermissionChecker>
	);
};

export default withUserType(withRouter(LifeCycleAnalyticsPage));
